import { defineStore } from "pinia";
import axios from "axios";

export const useRefundStore = defineStore({
  id: "refund",
  persist: true,
  state: () => ({
    refundData: null,
  }),
  actions: {
    setRefundData(refund) {
      this.refundData = refund;
    },
    getAllRefundsApi(data, token) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            process.env.VUE_APP_BASE_URL_API + "app/refund/getAllRefunds",
            data,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => reject(error));
      });
    },
    getAllOrderRefundsApi(data, token) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            process.env.VUE_APP_BASE_URL_API + "app/refund/getOrderRefunds",
            data,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => reject(error));
      });
    },
    requestRefundApi(data, token) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            process.env.VUE_APP_BASE_URL_API + "app/refund/requestRefund",
            data,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => reject(error));
      });
    },
    updateRefundStatusApi(data, token) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            process.env.VUE_APP_BASE_URL_API + "app/refund/updateRefundStatus",
            data,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => reject(error));
      });
    },
  },
});
